//店铺
// import shop from '@/views/shop'
// import productSales from '@/views/shop/productSales'
import order from '@/views/shop/order'
import Orderdetails1 from '@/views/shop/Orderdetails1'
import submit from '@/views/shop/submit'
import orderDetails from '@/views/shop/orderDetails'
import orderDetails2 from '@/views/shop/orderDetails2'
import submitDetails from '@/views/shop/submitDetails'
import activation from '@/views/shop/activation'
import history from '@/views/shop/history'
import activationList from '@/views/shop/activationList'
export default [
	{
		path: '/shop',
		name: 'shop',
		meta: [{ name: '店铺首页' }],
		component: resolve => require(['@/views/shop'], resolve)
	},
	{
		path: '/shop/productSales',
		name: 'productSales',
		meta: [{ name: '清单销售' }],
		component: resolve => require(['@/views/shop/productSales'], resolve)
	},
	{
		path: '/shop/order',
		name: 'order',
		meta: [{ name: '订单记录' }],
		component: order,
		//   meta: {
		//     keepAlive: true // 需要缓存
		//   }
	},
	{
		path: '/shop/Orderdetails1',
		name: 'Orderdetails1',
		meta: [{ name: '客户查询' }],
		component: Orderdetails1
	},
	{
		path: '/shop/order/orderDetails',
		name: 'orderDetails',
		meta: [
			{ name: '订单记录' },
			{ name: '订单记录详情' }
		],
		component: orderDetails
	},
	{
		path: '/shop/order/orderDetails2',
		name: 'orderDetails2',
		meta: [
			{ name: '订单记录' },
			{ name: '订单记录详情' }
		],
		component: orderDetails2
	},
	{
		path: '/shop/submit',
		name: 'submit',
		meta: [{ name: '意见反馈' }],
		component: submit
	},
	{
		path: '/shop/activation',
		name: 'activation',
		meta: [{ name: '实体卡激活' }],
		component: activation
	},
	{
		path: '/shop/history',
		name: 'history',
		meta: [{ name: '保障人变更' }],
		component: history
	},
	{
		path: '/shop/activationList',
		name: 'activationList',
		meta: [{ name: '实体卡激活记录' }],
		component: activationList
	},
	{
		path: '/shop/submit/submitDetails',
		name: 'submitDetails',
		meta: [{ name: '意见反馈' }, { name: '详情' }],
		component: submitDetails
	},
]



// WEBPACK FOOTER //
// ./src/router/shop.js